import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { Accordion, AccordionDetails, Box, Grid, Backdrop } from "@material-ui/core";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { useAppSelector } from "src/app-redux/hooks";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { getAllMultiContainerGateDocuments } from "src/app-redux/vehicle/actions/vehicleActions";
import { selectDocuments } from "src/app-redux/vehicle/vehicleSlice";
import { DocumentsInputs } from "./DocumentsInputs";
import Heading from "./Heading";
import { useStyles } from "./styles";
import CommonLoader from "src/components/Loader/CommonLoader";

type Props = {
  expand: boolean;
  updateExpandStatus: (type: number) => void;
};

export default function Documents({ expand, updateExpandStatus }: Props): React.ReactElement {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const { id } = useParams<{ id: any }>();
  const pageHeading = "File Attachments";
  const [vehicleConfiguration, setvehicleConfiguration] = useState([] as any[]);
  const getAllDocumentsFromStore = useAppSelector(selectDocuments);

  useEffect(() => {
    getVehicleConfiguration();
  }, []);

  const getVehicleConfiguration = async () => {
    try {
      setLoader(true);
      const results = await fetchWrapper.get("get-all-vehicle-configuration");
      if (results.isSuccess === true) {
        setvehicleConfiguration(results.value.fileCategoryData);
        return setLoader(false);
      }
    } catch (error: any) {
      setLoader(false);
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    }
  };
  const handlePanelChange = () => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    if (id) {
      updateExpandStatus(1);
      if (isExpanded) {
        getVehicleConfiguration();
        dispatch(getAllMultiContainerGateDocuments({ gatePassId: id }));
      }
    }
  };

  return (
    <>
      <Backdrop className={classes.backdrop} open={loader}>
        <CommonLoader />
      </Backdrop>
      <Box border={1} mb={2} borderColor="grey.200">
        <Accordion square elevation={0} expanded={expand} onChange={handlePanelChange()}>
          <Heading heading={pageHeading} />
          <Box borderTop={1} mb={1} borderColor="grey.200"></Box>
          <AccordionDetails>
            <Grid container direction="row">
              <Grid item xs={12} md={12}>
                <DocumentsInputs
                  submitCounter={0}
                  fileTypes={vehicleConfiguration}
                  getAllGateDocs={getAllDocumentsFromStore}
                  gatePassId={id}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
}
